module.exports = __webpack_public_path__ + "static/img/ic_empty_search@3x.07f02b6f.png";